import { useEffect } from "react";

const pmireddemedVideo = () => {
//   useEffect(() => {
//     window.parent.postMessage(
//       { action: "redirectTo", label: "points-history" },
//       "*"
//     );
//   }, []);

  return (
    <iframe
      src="https://pmi-salesforce.videomarketingplatform.co/v.ihtml/player.html?token=8cbe5ea238ad32ff6216ff357e7d9d3b&source=embed&photo%5fid=118727549&endOn=thumbnail"
      width="100%"
      height="600"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default pmireddemedVideo;
